module.exports = __webpack_public_path__ + "media/print/fonts_open-sans-2c5e9596.png";